// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.menu-link[data-v-322afedc]{padding-left:1.5rem!important;padding-right:1.2rem!important}span.spacer[data-v-322afedc]{padding:.75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
